<template>
  <div class="plan-list">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      addText=""
      :count='count'
      :current="page"
    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>门店:</label>
            <storeListSelect class="item" v-model="query.storeIdList" ></storeListSelect>
          </div>
          <div class="queryItem" >
            <goodsSearchItem :labelString="'商品'" v-model="query.goodName" :placeholder="'支持商品编码、通用名、商品名'"></goodsSearchItem>
        </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btn-wrap" v-if="handlePermission('addActivityCollection')">
          <lk-button class="mb8" type="primary" icon='md-add'  @click="addNew">添加</lk-button>
        </div>
        <lk-table
          border
          :columns='columns'
          :data='tableData'
          ></lk-table>
      </div>
    </QueryFrame>
    <lk-modal
      v-model="showConfigModal"
      title="添加活动收款配置"
      width="660px"
      :footer-hide='true'
      :mask-closable="false"
    >
    <lk-form
      :model='goodsInfo'
      :rules='validate'
      :label-width='64'
      label-position="right"
      ref="goodsInfo">
      <div class="cardContainer">
          <lk-row :gutter="1">
            <lk-col span='12'>
              <lk-form-item label='门店:' prop='storeId'>
                <storeListSelect class="item" v-model="goodsInfo.storeId" :multiple="true"></storeListSelect>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter="1">
            <lk-col span='12'>
              <lk-form-item label='商品:' prop='goodName'>
            <inputSearch
                :placeHolder="'商品编码、商品名、通用名称'"
                v-model.trim="goodsInfo.goodName"
                :columns='searchGoodsColumns'
                @getData='toGetDrugData'
                :data='searchData'
                @selected='handleSelect'
                :reset='false'
                :maxlength='35'
                style="width:250px;"
                class="margin-left"
              ></inputSearch>
              </lk-form-item>
            </lk-col>
          </lk-row>
      </div>
    </lk-form>
      <lk-table
        border
        :columns='searchColumns'
        :data='tableSelectData'
        >
      </lk-table>
      <div class="btn-cont">
        <lk-button v-if="handlePermission('addActivityCollection')" @click="addActivityCollection" class="mr" type='primary'>保存</lk-button>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import inputSearch from '../../components/InputSearch.vue';
import tools from '../../services/tools';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';

export default {
  name: 'activityCollectionConfig',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    inputSearch,
  },
  data() {
    return {
      showConfigModal: false,
      query: {
        storeIdList: [],
      },
      goodsInfo: {
        storeId: null,
        goodName: null,
      },
      validate: {
        storeId: [{ required: true, message: '请选择门店', type: 'number' }],
        goodName: [{ required: true, message: '请输入商品编码/商品名/通用名称' }],
      },
      searchGoodsColumns: [
        { title: '商品编码', key: 'drugSerialCode', width: '50px' },
        { title: '通用名', key: 'approvedDrugNames', width: '120px' },
        { title: '商品名', key: 'goodsName', width: '100px' },
        { title: '规格', key: 'specifications', width: '80px' },
        { title: '生产企业', key: 'manufacturer', width: '110px' },
        { title: '单位', key: 'drugMiniPackageUnitString', width: '100px' },
      ],
      searchColumns: [
        { title: '商品编码', key: 'drugSerialCode', minWidth: 116 },
        { title: '通用名', key: 'approvedDrugNames', minWidth: 116 },
        { title: '商品名', key: 'goodsName', minWidth: 116 },
        { title: '规格', key: 'specifications', minWidth: 80 },
        { title: '生产企业', key: 'manufacturer', minWidth: 116 },
        { title: '单位', key: 'drugMiniPackageUnitString', minWidth: 80 },
      ],
      searchData: [],
      tableSelectData: [],
      columns: [
        {
          title: '门店名称',
          minWidth: 116,
          key: 'storeName',
        },
        {
          title: '商品编码',
          minWidth: 116,
          key: 'serialCode',
        },
        {
          title: '商品通用名',
          minWidth: 116,
          key: 'approvedName',
        },
        {
          title: '商品名',
          minWidth: 116,
          key: 'goodsName',
        },
        {
          title: '规格',
          minWidth: 116,
          key: 'spec',
        },
        {
          title: '生产企业',
          minWidth: 116,
          key: 'manufacturer',
        },
        {
          title: '单位',
          minWidth: 116,
          key: 'unit',
        }, {
          title: '操作人',
          minWidth: 116,
          key: 'modifiedUserName',
        }, {
          title: '修改时间',
          minWidth: 136,
          key: 'modifiedTime',
        },
        {
          title: '状态',
          key: 'status',
          minWidth: 116,
          render: (h, params) => {
            const id = params.row.id;
            return h('lk-switch', {
              props: {
                size: 'large',
                value: params.row.status === 1,
              },
              on: {
                'on-change': (flag) => {
                  const Message = flag ? '该活动已启用' : '该活动已禁用';
                  const data = {
                    id,
                    status: flag ? 1 : 2,
                  };
                  tools.enableActivityCollection(data).then((res) => {
                    if (res.data.status === 200) {
                      this.$Message.success(Message);
                      this.getData();
                    } else {
                      this.$Message.error(res.data.error);
                      this.getData();
                    }
                  }).catch((err) => {
                    this.getData();
                    utils.handleError(err);
                  });
                },
              },
            },
            [
              h('span', {
                props: {
                },
                slot: 'open',
              }, '启用'),
              h('span', {
                props: {
                },
                slot: 'close',
              }, '禁用'),
            ]);
          },
        },
      ],
      tableData: [],
      goodTableData: [],
    };
  },
  methods: {
    clear() {
      this.page = 1;
      this.size = 20;
      this.query = {
        storeIdList: [],
      };
    },
    addNew() {
      this.showConfigModal = true;
    },
    // handleSearch() {
    //   this.getData();
    // },
    addActivityCollection() {
      const {
        storeId,
        goodsBaseId,
      } = this.goodsInfo;
      this.$refs.goodsInfo.validate((valid) => {
        if (valid) {
          const params = {
            storeId,
            goodsBaseId,
            // proceedsTypeId: , // 收款方式id，本次不用传
          };
          tools.addActivityCollection(params).then((res) => {
            if (res.data.status !== 200) {
              this.$Message.error(res.data.error);
              return;
            }
            this.getData();
            this.showConfigModal = false;
            this.goodsInfo = {};
            this.searchData = [];
            this.tableSelectData = [];
            this.$refs.goodsInfo.resetFields();
            this.$Message.success('保存成功');
          }).catch((err) => {
            utils.handleError(err);
          });
        }
      });
    },
    getData() {
      const params = {
        storeIdList: this.query.storeIdList,
        nameMix: this.query.goodName,
      };
      params.page = this.page;
      params.size = this.size;
      tools.getActivityCollectionList(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = item;
            item.createTime = utils.exchangeTimeToSecond(item.createTime);
            if (item.modifiedTime) item.modifiedTime = utils.exchangeTimeToSecond(item.modifiedTime);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    toGetDrugData() {
      const params = {
        nameMix: this.goodsInfo.goodName,
        page: 1,
        size: 100,
      };
      tools.getGoodsBaseList(params).then((res) => {
        if (res.data.status === 200) {
          this.searchData = res.data.data.list.map(item => item.goodsBase);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleSelect(obj) {
      this.tableSelectData = [obj];
      this.goodsInfo = Object.assign(this.goodsInfo, {
        goodsBaseId: obj.id,
      });
    },
  },
  mounted() {
    this.handleSearch(true);
  },
  computed: {
    disabled() {
      return this.tableSelectData.length > 0;
    },
  },
};
</script>
<style lang="less" scoped>
  .btn-cont {
    display: flex;
    margin-top: 16px;
    justify-content: flex-end;
  }
</style>
